// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + "." + {"77":"337860d8","274":"020128b1","352":"b0b98b72","835":"f8370210"}[chunkId] + ".js";
};